import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { VideoStatus } from "@parkschannel/contracts";
import { VideoCardWithTagsAndStatus } from "./VideoCardWithTagsAndStatus";
import { useVideoModalContext } from "../../Video";
import { ItemsList, Pagination } from "@parkschannel/ui";
export const UserVideoList = (param)=>{
    let { data  } = param;
    const { setSelectedVideo  } = useVideoModalContext();
    return /*#__PURE__*/ _jsx(ItemsList, {
        className: "w-full py-6 grid gap-4 md:gap-6 md:grid-cols-2 xl:grid-cols-3",
        items: data,
        noItemsMessage: "Videos not found",
        renderItem: (video)=>/*#__PURE__*/ _jsx(VideoCardWithTagsAndStatus, {
                data: video,
                onClick: video.status === VideoStatus.PUBLISHED ? (data)=>setSelectedVideo(data) : undefined
            })
    });
};
export const UserVideoListWithPagination = (param)=>{
    let { data , pagination , onPageChange  } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(UserVideoList, {
                data: data
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ _jsx(Pagination, {
                    pagination: pagination,
                    onPageChange: onPageChange
                })
            })
        ]
    });
};
